module.exports = __webpack_public_path__ + "static/media/Folking Desi.681fbec3.svg";